import { Avatar, Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';
import { useDispatch, useSelector } from 'react-redux';

const Item = ({ item, index, navigate, data, onClick, handleStream }) => {
  const dispatch = useDispatch();
  const { isMobile } = useSelector((state) => state.appState);

  function handleClick(index) {
    if (isMobile) return handleGetApp();
    onClick(index);
  }

  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  return (
    <Clickable onClick={() => handleClick(index)}>
      <Row noFlex wid="80px" centerAll>
        <Col noFlex center>
          <Avatar
            storiesSection
            unseenStory={!item.streamKey}
            streaming={!!item.streamKey}
            user={item?.owner || {}}
          />

          <Text
            c1
            marg="4px 0 0"
            col={theme.GREY_60}
            wid="80px"
            overflow="hidden"
            center
            textOverflow="ellipsis"
          >
            @{item?.owner?.username || ':)'}
          </Text>
        </Col>
      </Row>
    </Clickable>
  );
};

export default Item;
